module.exports = {"0":"Pendiente de aceptación","1":"Aceptada / en curso","2":"Rechazada","3":"Finalizada","4":"No contestada","5":"Cancelada"};